import React from "react";

function Header() {
  return (
    <header style={{
      width: "100%",
      padding: "18px 0",
      background: "#111",
      color: "white",
      fontWeight: "bold",
      fontSize: "1.4rem",
      textAlign: "center",
      letterSpacing: "1px",
      marginBottom: "2em"
    }}>
      <a
        href="/"
        style={{ color: "yellow", textDecoration: "none" }}
      >
        🏠 YLHQ List Manipulator — Home
      </a>
    </header>
  );
}

export default Header;
